<template>
  <div class="share-store-groupbuy-title">
    <img src="./images/logo.png" class="share-store-groupbuy-title-logo display-middle" alt="">
    <div class="display-middle share-store-groupbuy-title-content" v-text="shareTitle" />
  </div>
</template>

<script>
export default {
  props: {
    shareTitle: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="stylus" scoped>
  .share-store-groupbuy-title {
    padding-top: 25px;
    text-align center
    padding-bottom: 25px;
  }
  .share-store-groupbuy-title-logo {
    position:relative;
    display:block;
    margin: 0 auto;
    width: 87px;
    height: 39px;
  }
  .share-store-groupbuy-title-content {
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 500;
    color: #FFFFFF;
    padding-left: 8px;
  }
</style>
